export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M18 15.75v-5c0-3.07-1.64-5.64-4.5-6.32v-.68c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.11 6 7.67 6 10.75v5l-2 2v1h16v-1zm-5 0h-2v-2h2zm0-4h-2v-4h2zm-1 10c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2\"/>"
};